import _ from 'underscore';
import {Float} from "./input-float";

export const getConsiderProductPriceByTypePrice = (product, type_price, qty = 0, client_discount = 0) => {
    let product_price_find = _.find(product.prices, (i) => i.id === type_price.id),
        price_original = product_price_find ? product_price_find.pivot.price : product.price,
        price_new = price_original,
        isBlockDiscountClient = type_price.custom_setting ? !type_price.client_discount : product.not_discount_sum,
        isBlockDiscountProduct = type_price.custom_setting ? !type_price.product_discount : false,
        isBlockDiscountsProduct = type_price.custom_setting ? !type_price.product_discounts : false;

    if (!isBlockDiscountsProduct)
        price_new = getConsiderPriceByDiscounts(product, price_original, qty);
    if (!isBlockDiscountProduct && price_new === price_original)
        price_new = getConsiderPriceByDiscount(product, price_original);
    if (!isBlockDiscountClient && client_discount)
        price_new = Float(price_new - (client_discount / 100 * price_new));
    return {
        price_consider: price_new,
        price_original: price_original
    };
};

const getConsiderPriceByDiscount = (product, price) => {
    let price_new = price;
    if (product.discount && price) {
        price_new = Float(price - (!product.discount_percent ? product.discount : (product.discount / 100 * price)))
    }
    return price_new;
};

const getConsiderPriceByDiscounts = (product, price, qty) => {
    let price_new = price,
        qty_discounted = 0,
        discount = 0,
        percent = true;
    if (product.discounts && product.discounts.length && price && qty) {
        _.each(product.discounts, (i) => {
            if (Number(qty) >= Number(i.qty) && Number(i.qty) > Number(qty_discounted)) {
                qty_discounted = Number(i.qty);
                discount = Number(i.discount);
                percent = i.percent;
            }
        });
        if (qty_discounted && discount) {
            price_new = Float(price - (!percent ? discount : (discount / 100 * price)))
        }
    }
    return price_new;
};